module.exports = ".login-title-container{background-color:#D7DADB;color:#5d7288}.cat-container{margin:0 -15px}.cat-container a.nav-link.active{background-color:white;color:#0050A2;border:1px solid #c0c0c0;border-bottom:none;border-top-left-radius:3px;border-top-right-radius:3px}.cat-container a.nav-link.active .tag-pill{background-color:white;color:#0050A2}.required{color:#c10042;font-size:12px}.form-control{color:#263b4c}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/login/login.component.scss
// module id = 425
// module chunks = 1